import { Input, Output, EventEmitter, Directive, TemplateRef, ContentChild } from '@angular/core';
import { GridHeadeTopDropdownTemplateDirective } from './grid-header-top-search.template.directive';

@Directive({
  selector: 'grid-header-top-dropdown',
  standalone: false,
})
export class GridHeaderTopDropdownDirective {
  // @Input()
  @ContentChild(GridHeadeTopDropdownTemplateDirective, { read: TemplateRef })
  template: TemplateRef<any>;
}
